module.exports = __webpack_public_path__ + "6edd2ddc1e6019d84d0863e4d7c7941a.png";